module.exports = __webpack_public_path__ + "img/caas1.b911c186.webp";